(function($) {
    $(function() {
        if (localStorage.getItem("theme") === 'false') {           
            $('html').addClass("dark-mode");
            $('.contrast-switch input').prop('checked', false);
        }
        $('header .wp-block-navigation-container-open').on('click', function(e) {
            $('#modal-1').toggleClass("is-menu-open");
            e.stopPropagation();
        });
        
        $('.wp-block-navigation-container-close').on('click', function() {
            $('.wp-block-navigation-container').removeClass("is-menu-open");
        });       

        $('header .wp-block-navigation-container').on('click', function(e) {
            e.stopPropagation();
        }); 

        $('body').on('click', function() {
            $('.wp-block-navigation-container').removeClass("is-menu-open");
        });

        $('.contrast-switch input').on('click', function() {
            localStorage.setItem("theme", $(this).is(':checked') + '' );           
            $('html').toggleClass("dark-mode");       
        });
        
        $('.search-menu').on('click', function() {
            $(this).find('.dropdown').toggleClass("menu-select");
        });

        $('.search-menu .dropdown [data-for]').on('click', function() {
            var $this = $(this);
            $this.closest('.search-menu').find('.preview').empty().append($this.clone());
            $this.closest('.search-container').find('input').trigger("input");
        });

        /* Autosuggest in search box */

        function escapeForHTML(s) {
            return s.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;");
        }

        var currentAutosuggestedRequestLength;
        var numberOfAutosuggestionsGotten;
        var currentNumberOfRenderedAutosuggestions = 0;
        var forShop;

        $.widget( "custom.searchtagautocomplete", $.ui.autocomplete, {
            _renderItem: function( ul, item ) {
                var returnValue = $( "<li>" ).addClass( "autosuggestion" );
                if(currentNumberOfRenderedAutosuggestions++ === numberOfAutosuggestionsGotten && forShop) {
                    forShop ? returnValue.html( "<span><span class='full-text-search-suggestion'>" + I18N["autosuggest-fulltextlabel"] + "</span><span class='autosuggestion-emphasis'>" + escapeForHTML(item.value) + "</span></span>" ) : returnValue.html("");
                } else {
                    returnValue.html( "<span><span class='autosuggestion-emphasis'>" + escapeForHTML(item.value.substr(0, currentAutosuggestedRequestLength)) + "</span>" + escapeForHTML(item.value.substr(currentAutosuggestedRequestLength)) + "</span>" );
                }
                return returnValue.appendTo( ul );
            }
        });

        $('.search input, .search-shop input').each(function() {
            var rId = "rId" + ("" + Math.random()).substring(2);
            var $this = $(this);
            $this.closest(".search-generic-container").find(".search-resultat").attr("id", rId);
            $this.searchtagautocomplete({
                delay: 0,
                minLength: 1,
                source: function(request, response) {
                    var returnValue = [];
                    var $searchFor = $this.closest('.search-generic-container').find('.preview [data-for]');
                    if ($searchFor.data("for") === "shop") {
                        forShop = true;
                        // Original url
                        // url: "https://www.grin.com/rpc/tag_search",
                        $.ajax({
                            url: "/rpc/tag_search",
                            data: {
                                method: "get_query",
                                q: request.term,
                                limit: 11,
                                timestamp: new Date().getTime(),
                                lang: document.documentElement.lang.substring(0, 2)
                            }
                        }).done(function(data) {
                            if(data.hasOwnProperty("tag_list") && Array.isArray(data.tag_list)) {
                                data.tag_list.forEach(function(tag) {
                                    returnValue.push(tag.keyword);
                                });
                            }
                        }).always(function() {
                            numberOfAutosuggestionsGotten = returnValue.length;
                            returnValue.push(request.term);
                            currentAutosuggestedRequestLength = request.term.length;
                            currentNumberOfRenderedAutosuggestions = 0;
                            response(returnValue);
                        });
                    } else {
                        forShop = false;
                        response([]);
                    }
                },
                select: function( event, ui ) {
                    var t = this;
                    setTimeout(function() {                     // wait for jQ to have updated the input
                        evalEnter.call(t, {}, true);
                    }, 0);
                },
                position: {
                    my: "left-1 top+1"
                },
                appendTo: "#" + rId
            });
        })

        function evalEnter(e, override) {
            if(override === true || e.key === "Enter") {
                var query = this.value;
                var $searchFor = $(this).closest('.search-generic-container').find('.preview [data-for]');
                if ($searchFor.data('for') === 'shop') {
                    window.location.assign('/search?searchstring=' + encodeURIComponent(query) + '&product=ebook&source_type=document&field=title%2Csubtitle%2Cdata&lang=' + document.documentElement.lang.substring(0, 2));
                } else {
                    window.location.assign('/tutorialssuche?find=' + query.toLocaleLowerCase().split(/[,;]/).map(function(e) {
                        return encodeURIComponent(e);
                    }).filter(function(e) {
                        return e.trim().length > 0;
                    }).join(','));
                }
                e.stopPropagation();
            }
        }

        $('.search input, .search-shop input').on('keydown', evalEnter);
        $('form.search').on('submit', function() {
            return false;
        });

        if(location.search.indexOf("?find=") === 0) {
            $('.search input').val(location.search.substring("?find=".length).split(",").map(function(e) {
                return decodeURIComponent(e);
            }).join(" "));
            $('.search-menu .preview').empty().append($('.search-menu [data-for="tutorial"]').clone());
        }

        $('.wp-block-aioseo-faq').on('click', function() {
            $(this).find('>.aioseo-faq-block-question').toggleClass("faq-open");
        });

        $('#languageSelectorTarget').append($('#languageSelector'));


        function openModule(e) {
            if(!e.target.tagName.toLowerCase() !== "a") {
                var a = $(this).find(".wp-block-read-more");
                a.length && a[0].click();
            }
        }

        $(".module-container").on("click", openModule);
    });
})(jQuery);